<template>
    <div>
        <div style="width:100%;">
            <transition name="fade">
            <div v-if="informativo == true && !fechado">
                <div :class="'status-box-condicoes '+(informativo ? 'informativo' : '')">
                    <span class="span-close" @click="fechado = true"><i class="fa fa-close"></i></span>
                    <p v-html="message_informativo"></p>
                </div>
            </div>
            </transition>
        </div>
        <br>
    </div>        
</template>
<script>
    export default {
        name: 'MensagemBoxLeilao',
        props: ['message_informativo','informativo'],
        data() {
            return {
                fechado: false
            }
        },
        watch: {
            message_informativo() {
                this.fechado = false
            }
        }
    }
</script>
<style scoped>
    .status-box-condicoes{ 
        width: 100%;
        padding: 15px 15px 6px;
        margin: 4px 0 0;
        border-radius: 3px;
        background: #70c8ff;
        position: relative;
    }
    .status-box-condicoes p{
        color: #fff;
        font-size:17px;
        width: 97%;
    }
    .status-box-condicoes.liberado{ background: #5ece72; }
    .span-close{
        cursor: pointer;
        position: absolute;
        top: 8px;
        right: 10px;
        text-align: center;
        padding: 4px 11px;
        font-size: 20px;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/MensagemBoxLeilao.vue